// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import 'url-search-params-polyfill'
import Vue from 'vue'
import App from './App'
import router from './router'
import promise from 'es6-promise'
import axios from 'axios'
import ElementUI from 'element-ui'
// import { postAjax } from '@/api/index'
import { postAjax, getNowDate } from '@/api/getPv'
// eslint-disable-next-line no-unused-vars
import 'element-ui/lib/theme-chalk/index.css'
promise.polyfill()
axios.defaults.withCredentials = true
Vue.config.productionTip = false
Vue.prototype.$http = axios
Vue.prototype.$qs = axios
Vue.use(ElementUI)
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'
// 路由变化跳转页面回到顶部
router.beforeEach((to, from, next) => {
  var params = {
    name: '综合信息支撑服务子平台',
    accessTime: getNowDate(),
    code: 7,
    visitType: '1',
    userId: '',
    userName: '',
    maxComplicationNum: 10
  }
  document.body.scrollTop = 0
  // firefox
  document.documentElement.scrollTop = 0
  // safari
  // window.pageYOffset = 0
  if (to.path) {
    postAjax({
      url: 'https://pvcj.miit.gov.cn:5001/api/mis/addpv',
      data: params,
      success: function () {
        console.log('访问成功')
      }
    })

    if (window._hmt) {
      window._hmt.push(['_trackPageview', '/#' + to.fullPath])
    }
  }
  next()
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js